import React from 'react'
import { useLocation } from '@gatsbyjs/reach-router'
import { trackClick } from '../analyticsUtils'
import Box from './primitives/Box'
import Button from './system/Button'

const pathnamesWithoutCTAButtons = ['/cto-craft-con', '/pointer-io', '/demo']

export function HeaderButtons({
  isDark,
  isMenuActive,
}: {
  isDark: boolean
  isMenuActive: boolean
}) {
  const pathname = useLocation().pathname
  const isPathWithCtaButtons = !pathnamesWithoutCTAButtons.some(path =>
    pathname.startsWith(path),
  )

  return (
    <>
      {isPathWithCtaButtons && (
        <>
          <Box display={{ xs: isMenuActive ? 'flex' : 'none', sm: 'flex' }}>
            <TrialButton isDark={isDark} />
            <DemoButton />
          </Box>
        </>
      )}
      <LoginButton isDark={isDark} />
    </>
  )
}

function TrialButton({ isDark }: { isDark: boolean }) {
  return (
    <Button
      onClick={trackClick('Header - Trial Button')}
      size="medium"
      variant={isDark ? 'secondaryWithBorder' : 'lightSecondaryWithBorder'}
      href="https://app.swarmia.com/signup/"
    >
      Start free trial
    </Button>
  )
}

function DemoButton() {
  return (
    <Button
      onClick={trackClick('Header - Demo Button')}
      size="medium"
      variant="primary"
      href="/demo/"
      marginLeft={12}
    >
      Get a demo
    </Button>
  )
}

function LoginButton({ isDark }: { isDark: boolean }) {
  return (
    <Button
      href="https://app.swarmia.com/"
      size="medium"
      display={{ xs: 'none', desktopMenu: 'flex' }}
      variant={isDark ? 'lightGhost' : 'ghost'}
    >
      Log in
    </Button>
  )
}
